// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"415":"63c56532","480":"0c843683","606":"295037c7","838":"5f0cdc08"}[chunkId] + ".js";
};